"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { routes } from "@/constants";
import { useIsMobileView } from "@/hooks";
import { LoadingSpinner } from "@focal/ui-kit";

export default function Home() {
  const router = useRouter();
  const isMobile = useIsMobileView();

  useEffect(() => {
    if (isMobile) {
      router.push(routes.inPersonMobile.index);
    } else {
      router.push(routes.home.index);
    }
  }, [isMobile, router]);

  return (
    <div className="flex min-h-screen flex-1 justify-center items-center">
      <LoadingSpinner />
    </div>
  );
}
